var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54182 7.91797C2.00011 7.86468 1.5943 7.70197 1.32214 7.4298C0.833984 6.94168 0.833984 6.15597 0.833984 4.58464V4.3763C0.833984 2.80495 0.833984 2.01928 1.32214 1.53112C1.8103 1.04297 2.59597 1.04297 4.16732 1.04297H5.83398C7.40532 1.04297 8.19102 1.04297 8.67915 1.53112C9.16732 2.01928 9.16732 2.80495 9.16732 4.3763V4.58464C9.16732 6.15597 9.16732 6.94168 8.67915 7.4298C8.19102 7.91797 7.40532 7.91797 5.83398 7.91797C5.60044 7.92318 5.41444 7.94093 5.23173 7.98255C4.7324 8.09751 4.27003 8.35301 3.8131 8.57584C3.16202 8.8933 2.83648 9.05205 2.63219 8.90343C2.42789 8.7548 2.45621 8.33543 2.54182 7.91797Z",
    fill: "#595959",
    stroke: "#595959",
    strokeWidth: 0.625,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 5.6263H6.66927M3.33594 3.54297H5.0026",
    stroke: "#F3F3F3",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsFilled);
export default __webpack_public_path__ + "static/media/SmsFilled.63be1d60937057ffb9c2500dd69aae93.svg";
export { ForwardRef as ReactComponent };